import { graphql } from "gql";

const DELETE_FILE_MUTATION = graphql(`
  mutation DeleteFile($id: ID!) {
    deleteFile(id: $id) {
      id
    }
  }
`);

export default DELETE_FILE_MUTATION;
